import { render, staticRenderFns } from "./ExcelUserDetails.vue?vue&type=template&id=655062f4&"
import script from "./ExcelUserDetails.vue?vue&type=script&lang=js&"
export * from "./ExcelUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports